<template>
  <div class="basic_wrap choose-page">
    <header class="page-top">
      <h1 class="choose-title">
        {{ $t('homeDesign.dating') }}
      </h1>
      <button
        type="button"
        class="area-label"
        :aria-expanded="areaOpen"
        aria-controls="area-filter"
        @click="toggleArea"
      >
        <img
          class="area-icon"
          src="../images/ban6/icon_location.png"
          alt=""
        >
        <span>{{ $t('chooseDesign.area') }}</span>
        <img
          class="area-arrow"
          :class="{ 'is-open': areaOpen }"
          src="../images/ban6/down.png"
          alt=""
        >
      </button>
    </header>

    <section
      v-if="areaOpen"
      id="area-filter"
      class="area-filter"
    >
      <button
        type="button"
        class="area-option"
        :class="{ active: selectedClassId === 0 }"
        @click="selectArea(0)"
      >
        {{ $t('chooseDesign.all') }}
      </button>
      <button
        v-for="area in areas"
        :key="area.id"
        type="button"
        class="area-option"
        :class="{ active: selectedClassId === Number(area.id) }"
        @click="selectArea(Number(area.id))"
      >
        {{ area.name }}
      </button>
    </section>

    <div
      ref="content"
      class="tab-content"
    >
      <van-empty
        v-if="empty"
        :description="$t('orders.noOrders')"
      />
      <van-list
        v-else
        v-model="loading"
        :finished="finished"
        :immediate-check="false"
        :offset="100"
        :loading-text="$t('pro2.loading')"
        @load="loadGirls"
      >
        <div
          v-if="girls.length"
          class="girl-grid"
        >
          <article
            v-for="(item, index) in girls"
            :key="item.id || index"
            class="girl-card"
            @click="$router.push('/vprofile/' + item.id)"
          >
            <img
              class="girl-photo"
              :src="formatAssetUrl(item.pic)"
              alt=""
            >
            <img
              class="live-icon"
              src="../images/ban6/lives.gif"
              alt=""
            >
            <span class="corner-ribbon">
              <i>{{ $t('sky.renzheng') }}</i>
            </span>
            <div class="card-info">
              <div class="name-row">
                <span class="girl-name">{{ displayValue(item.name) }}</span>
                <span class="region-chip">{{ displayValue(item.addr) }}</span>
              </div>
              <div class="metric-row">
                <span
                  class="metric-item"
                  :aria-label="$t('homeDesign.likes') + ': ' + displayValue(item.zan)"
                >
                  <img
                    src="../images/ban6/icon_views.png"
                    alt=""
                  >
                  <span>{{ displayValue(item.zan) }}</span>
                </span>
                <span
                  v-if="hasGirlScore(item)"
                  class="metric-item metric-score"
                  :aria-label="$t('videoPage.score', { score: formatGirlScore(item.score) })"
                >
                  <img
                    src="../images/ban6/icon_love.png"
                    alt=""
                  >
                  <span>{{ formatGirlScore(item.score) }}</span>
                </span>
              </div>
            </div>
          </article>
        </div>
      </van-list>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Empty, List } from "vant";
import Fetch from "../../utils/fetch";
import { formatAssetUrl } from "../../utils/assets";

Vue.use(Empty).use(List);

export default {
	name: "Choose",
	data() {
		return {
			loading: false,
			page: 1,
			girls: [],
			finished: false,
			empty: false,
			requestLock: false,
			requestVersion: 0,
			areas: [],
			selectedClassId: 0,
			areaOpen: false,
		};
	},
	created() {
		this.$parent.footer("girl", true);
	},
	mounted() {
		if (localStorage.getItem("token") == null) {
			this.$router.push("/login");
			return;
		}
		this.loadGirls();
	},
	beforeDestroy() {
		this.requestVersion++;
	},
	methods: {
		formatAssetUrl,
		hasGirlScore(item) {
			var score = Number(item && item.score);

			return isFinite(score) && score > 0;
		},
		formatGirlScore(value) {
			var score = Number(value);

			return isFinite(score) && score > 0 ? (Math.round(score * 10) / 10).toFixed(1) : "--";
		},
		displayValue(value) {
			return value !== undefined && value !== null && String(value).trim() !== "" ? value : "--";
		},
		toggleArea() {
			this.areaOpen = !this.areaOpen;
		},
		selectArea(classId) {
			this.areaOpen = false;
			if (this.selectedClassId === classId) return;
			this.selectedClassId = classId;
			this.resetGirls();
		},
		resetGirls() {
			this.requestVersion++;
			this.requestLock = false;
			this.loading = false;
			this.page = 1;
			this.girls = [];
			this.finished = false;
			this.empty = false;
			if (this.$refs.content) this.$refs.content.scrollTop = 0;
			this.$nextTick(() => this.loadGirls());
		},
		loadGirls() {
			if (this.requestLock || this.finished) {
				this.loading = false;
				return;
			}
			var version = this.requestVersion;
			this.requestLock = true;
			Fetch("/index/girls", {
				page: this.page,
				class_id: this.selectedClassId,
			}).then(r => {
				if (version !== this.requestVersion) return;
				var rows = r.data && r.data.list ? r.data.list : [];
				this.areas = r.data && Array.isArray(r.data.classes) ? r.data.classes : this.areas;
				if (rows.length > 0) {
					this.girls = this.girls.concat(rows);
					this.page++;
				}
				this.empty = this.girls.length === 0;
				this.finished = !(r.data && r.data.has_more);
				this.loading = false;
				this.requestLock = false;
			}).catch(() => {
				if (version !== this.requestVersion) return;
				this.loading = false;
				this.requestLock = false;
				this.finished = true;
			});
		},
	},
};
</script>

<style lang="less" scoped>
.choose-page {
	--accent: #f3c99e;
	--muted: #c5c5c5;
	display: flex;
	flex-direction: column;
	height: 100vh;
	min-height: 0;
	background: #171619;
	color: var(--accent);
	overflow: hidden;
}

.page-top {
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;
	flex: 0 0 38px;
	min-width: 0;
	border-bottom: 1px solid #302827;
	background: #201c1d;
	box-sizing: border-box;
}

.choose-title {
	max-width: 42%;
	margin: 0;
	font-size: 14px;
	line-height: 20px;
	font-weight: 400;
	text-align: center;
	overflow-wrap: anywhere;
}

.area-label {
	position: absolute;
	right: 7px;
	display: flex;
	align-items: center;
	max-width: 27%;
	padding: 0;
	border: 0;
	background: transparent;
	color: var(--accent);
	font-size: 14px;
	line-height: 20px;
	cursor: pointer;
}

.area-label span {
	min-width: 0;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.area-icon {
	flex: 0 0 18px;
	width: 18px;
	height: 18px;
}

.area-arrow {
	flex: 0 0 16px;
	width: 16px;
	height: 16px;
	margin-left: 3px;
	transition: transform 0.18s ease;
}

.area-arrow.is-open {
	transform: rotate(180deg);
}

.area-filter {
	display: flex;
	flex-wrap: wrap;
	align-content: flex-start;
	gap: 16px 20px;
	padding: 22px 22px 38px;
	border-bottom: 1px solid #4a4035;
	background: linear-gradient(110deg, #232323, #303030);
	box-sizing: border-box;
}

.area-option {
	max-width: 100%;
	min-height: 29px;
	padding: 4px 16px;
	border: 1px solid #6e5943;
	border-radius: 6px;
	background: transparent;
	color: var(--accent);
	font: inherit;
	font-size: 12px;
	line-height: 18px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	cursor: pointer;

	&.active {
		border-color: var(--accent);
		background: rgba(243, 201, 158, 0.17);
		color: #f5cfa8;
	}

	&:active {
		background: rgba(243, 201, 158, 0.12);
	}
}

.tab-content {
	flex: 1;
	min-height: 0;
	overflow-y: auto;
	padding-bottom: calc(70px + env(safe-area-inset-bottom));
	-webkit-overflow-scrolling: touch;
}

.girl-grid {
	display: grid;
	grid-template-columns: repeat(2, minmax(0, 1fr));
	column-gap: 12px;
	row-gap: 15px;
	padding: 12px 6px 12px;
}

.girl-card {
	position: relative;
	min-width: 0;
	aspect-ratio: 0.86 / 1;
	overflow: hidden;
	border: 4px solid #786851;
	border-radius: 9px;
	background: #292523;
	box-sizing: border-box;
	cursor: pointer;
}

.girl-photo {
	display: block;
	width: 100%;
	height: 100%;
	object-fit: cover;
	object-position: center;
}

.live-icon {
	position: absolute;
	top: 8px;
	left: 7px;
	width: 18px;
	height: 19px;
}

.corner-ribbon {
	position: absolute;
	top: 9px;
	right: -27px;
	width: 90px;
	height: 20px;
	transform: rotate(45deg);
	background: var(--accent);
	color: #171619;
	text-align: center;
}

.corner-ribbon i {
	display: block;
	padding: 0 10px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	font-size: 10px;
	line-height: 20px;
	font-style: normal;
}

.card-info {
	position: absolute;
	right: 0;
	bottom: 0;
	left: 0;
	padding: 4px 7px 5px;
	background: rgba(45, 43, 43, 0.55);
}

.name-row {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 5px;
	min-width: 0;
}

.girl-name {
	min-width: 0;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	font-size: 12px;
	line-height: 16px;
	font-weight: 700;
}

.region-chip {
	flex: 0 1 auto;
	max-width: 48%;
	min-width: 0;
	padding: 0 9px;
	border-radius: 12px;
	background: var(--accent);
	color: #624b35;
	font-size: 10px;
	line-height: 14px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	box-sizing: border-box;
}

.metric-row {
	display: flex;
	align-items: center;
	gap: 10px;
	margin-top: 3px;
	color: var(--muted);
	font-size: 10px;
	line-height: 13px;
	font-weight: 700;
}

.metric-item {
	display: flex;
	align-items: center;
	gap: 3px;
	min-width: 0;
}

.metric-item img {
	flex: 0 0 12px;
	width: 12px;
	height: 12px;
	object-fit: contain;
}

.metric-item span {
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.metric-score {
	color: #f3c99e;
}

/deep/ .van-empty {
	padding-top: 72px;
}

/deep/ .van-empty__description,
/deep/ .van-list__loading,
/deep/ .van-list__finished-text {
	color: var(--muted);
}
</style>
